// // AmountBreakdownGridResponsive.jsx
// import { Box, Typography, useTheme } from "@mui/material";
// import { tokens } from "../../../theme/theme";

// // Indian currency/number formatting
// const formatAmt = (v, currency = "₹") => {
//     const n = Number(v ?? 0);
//     return isNaN(n)
//         ? ""
//         : `${currency} ${n.toLocaleString("en-IN", {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//         })}`;
// };

// // Pair tile: internal 2-col grid (label | value)
// function PairTile({ label, value, emphasize = false }) {
//     return (
//         <Box
//             sx={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr fit-content(140px)", // fixed-ish compact value column
//                 border: 1,
//                 borderColor: "divider",
//                 borderRadius: 0.5,
//                 overflow: "hidden",
//                 minHeight: 32,
//             }}
//         >
//             <Box
//                 sx={{
//                     bgcolor: (t) => (t.palette.mode === "dark" ? "action.selected" : "action.hover"),
//                     px: 1,
//                     display: "flex",
//                     alignItems: "center",
//                 }}
//             >
//                 <Typography >{label}</Typography>
//                 {/* variant="caption" */}
//             </Box>
//             <Box
//                 sx={{
//                     px: 1,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                     fontWeight: emphasize ? 600 : 400,
//                 }}
//             >
//                 <Typography variant="body2">{value}</Typography>
//             </Box>
//         </Box>
//     );
// }

// export default function AmountBreakdownGrid({
//     currency = "₹",

//     totalQtyKg = 0,
//     grossAmount = 0,
//     discountAmount = 0,
//     totalAmount = 0,

//     freightPerMt = 0,
//     freightAmount = 0,
//     insuranceRatePct = 0,
//     insuranceAmount = 0,

//     serviceChargePct = 0,
//     serviceChargeAmount = 0,
//     taxableAmount = 0,
//     taxAmount = 0,

//     cessRatePct = 0,
//     cessAmount = 0,
//     roundOff = 0,
//     saleAmount = 0,

//     tcsRatePct = 0,
//     tcsAmount = 0,
//     netAmount = 0,
// }) {


//        const theme = useTheme();
//         const colors = tokens(theme.palette.mode);
//     // Data list in the display order
//     const items = [
//         { label: "Total Qty (in Kgs)", value: totalQtyKg?.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
//         { label: `Freight Amount / MT ${currency}`, value: Number(freightPerMt ?? 0).toFixed(4) },
//         { label: "Service Charge %", value: Number(serviceChargePct ?? 0).toFixed(2) },
//         { label: "Cess Rate %", value: Number(cessRatePct ?? 0).toFixed(2) },
//         { label: "TCS Rate %", value: Number(tcsRatePct ?? 0).toFixed(2) },

//         { label: `Gross Amount ${currency}`, value: formatAmt(grossAmount, currency) },
//         { label: `Freight Amount ${currency}`, value: formatAmt(freightAmount, currency) },
//         { label: `S.Charge Amount ${currency}`, value: formatAmt(serviceChargeAmount, currency) },
//         { label: `Cess Amount ${currency}`, value: formatAmt(cessAmount, currency) },
//         { label: `TCS Amount ${currency}`, value: formatAmt(tcsAmount, currency) },

//         { label: `Discount Amount ${currency}`, value: formatAmt(discountAmount, currency) },
//         { label: "Insurance Rate %", value: Number(insuranceRatePct ?? 0).toFixed(2) },
//         { label: `Taxable Amount ${currency}`, value: formatAmt(taxableAmount, currency) },
//         { label: "Round Off", value: Number(roundOff ?? 0).toFixed(2) },
//         { label: `Net Amount ${currency}`, value: formatAmt(netAmount, currency), emphasize: true },

//         { label: `Total Amount ${currency}`, value: formatAmt(totalAmount, currency) },
//         { label: `Insurance Amount ${currency}`, value: formatAmt(insuranceAmount, currency) },
//         { label: `Tax Amount ${currency}`, value: formatAmt(taxAmount, currency) },
//         { label: `Sale Amount ${currency}`, value: formatAmt(saleAmount, currency), emphasize: true },
//     ];



//     return (
//         <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1, overflow: "hidden" }}>
//             {/* Header */}
//             <Box
//                 sx={{
//                     px: 1,
//                     py: 0.5,
//                     // bgcolor: (t) => (t.palette.mode === "dark" ? "grey.800" : "grey.100"),
//                     bgcolor:colors.primary[400],
//                     borderBottom: 1,
//                     borderColor: "divider",
//                 }}
//             >
//                 {/* variant="caption" */}
//                 <Typography >Amount Details / Breakdown</Typography>
//             </Box>

//             {/* Responsive grid of tiles */}
//             <Box
//                 sx={{
//                     display: "grid",
//                     gap: 0.5,
//                     // Responsive min column width; auto-fit packs as many tiles as fit per row
//                     gridTemplateColumns: {
//                         xs: "repeat(auto-fit, minmax(220px, 1fr))",
//                         sm: "repeat(auto-fit, minmax(240px, 1fr))",
//                         md: "repeat(auto-fit, minmax(260px, 1fr))",
//                         lg: "repeat(auto-fit, minmax(280px, 1fr))",
//                         xl: "repeat(auto-fit, minmax(300px, 1fr))",
//                     },
//                     p: 0.5,
//                 }}
//             >
//                 {items.map((it, idx) => (
//                     <PairTile key={idx} label={it.label} value={it.value} emphasize={!!it.emphasize} />
//                 ))}
//             </Box>
//         </Box>
//     );
// }


import { Box, Typography, TextField, useTheme } from "@mui/material";
import { tokens } from "../../../theme/theme";

// Indian currency formatting
const formatAmt = (v, currency = "₹") => {
    const n = Number(v ?? 0);
    return isNaN(n)
        ? ""
        : `${currency} ${n.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
};

// Reusable pair tile (label | value or editable field)
function PairTile({ label, value, emphasize = false, editable = false, onChange }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr fit-content(140px)",
                border: 1,
                borderColor: "divider",
                borderRadius: 0.5,
                overflow: "hidden",
                minHeight: 32,
            }}
        >
            {/* Label */}
            <Box
                sx={{
                    bgcolor: (t) =>
                        t.palette.mode === "dark" ? "action.selected" : "action.hover",
                    px: 1,
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Typography>{label}</Typography>
            </Box>

            {/* Value / Editable field */}
            <Box
                sx={{
                    px: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    fontWeight: emphasize ? 600 : 400,
                }}
            >
                {editable ? (
                    <TextField
                        variant="standard"
                        value={value}
                        onChange={(e) => onChange?.(parseFloat(e.target.value) || 0)}
                        inputProps={{
                            style: { textAlign: "right", width: 80 },
                        }}
                    />
                ) : (
                    <Typography variant="body2">{value}</Typography>
                )}
            </Box>
        </Box>
    );
}

export default function AmountBreakdownGrid({
    currency = "₹",

    totalQtyKg = 0,
    grossAmount = 0,
    discountAmount = 0,
    totalAmount = 0,

    freightPerMt = 0,
    freightAmount = 0,
    insuranceRatePct = 0,
    insuranceAmount = 0,

    serviceChargePct = 0,
    serviceChargeAmount = 0,
    taxableAmount = 0,
    taxAmount = 0,

    cessRatePct = 0,
    cessAmount = 0,
    roundOff = 0,
    saleAmount = 0,

    tcsRatePct = 0,
    tcsAmount = 0,
    netAmount = 0,

    // Editable field handlers
    onChangeFreightPerMt,
    onChangeServiceCharge,
    onChangeCessRate,
    onChangeTcsRate,
    onChangInsuranceCharge,
    manualTCSRateEdit
}) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Ordered display list
    const items = [
        {
            label: "Total Qty (in Kgs)",
            value: totalQtyKg?.toLocaleString("en-IN", {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
            }),
        },
        {
            label: `Freight Amount / MT ${currency}`,
            value: Number(freightPerMt ?? 0).toFixed(2),
            editable: true,
            onChange: onChangeFreightPerMt,
        },

        {
            label: "Service Charge %",
            value: Number(serviceChargePct ?? 0).toFixed(2),
            editable: true,
            onChange: onChangeServiceCharge,
        },
        {
            label: "Cess Rate %",
            value: Number(cessRatePct ?? 0).toFixed(2),
            editable: true,
            onChange: onChangeCessRate,
        },
        {
            label: "TCS Rate %",
            value: Number(tcsRatePct ?? 0).toFixed(2),
            editable: manualTCSRateEdit,
            onChange: onChangeTcsRate,
        },

        // Display-only computed values
        { label: `Gross Amount ${currency}`, value: formatAmt(grossAmount, currency) },
        { label: `Freight Amount ${currency}`, value: formatAmt(freightAmount, currency) },
        { label: `S.Charge Amount ${currency}`, value: formatAmt(serviceChargeAmount, currency) },
        { label: `Cess Amount ${currency}`, value: formatAmt(cessAmount, currency) },
        { label: `TCS Amount ${currency}`, value: formatAmt(tcsAmount, currency) },

        { label: `Discount Amount ${currency}`, value: formatAmt(discountAmount, currency) },
        // { label: "Insurance Rate %", value: Number(insuranceRatePct ?? 0).toFixed(2) },
           {
            label: "Insurance Rate %",
            value: Number(insuranceRatePct ?? 0).toFixed(2),
            editable: false,
            onChange: onChangInsuranceCharge,
        },
        { label: `Taxable Amount ${currency}`, value: formatAmt(taxableAmount, currency) },
        { label: "Round Off", value: Number(roundOff ?? 0).toFixed(2) },
        { label: `Net Amount ${currency}`, value: formatAmt(netAmount, currency), emphasize: true },

        { label: `Total Amount ${currency}`, value: formatAmt(totalAmount, currency) },
        { label: `Insurance Amount ${currency}`, value: formatAmt(insuranceAmount, currency) },
        { label: `Tax Amount ${currency}`, value: formatAmt(taxAmount, currency) },
        { label: `Sale Amount ${currency}`, value: formatAmt(saleAmount, currency), emphasize: true },
    ];

    return (
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1, overflow: "hidden" }}>
            {/* Header */}
            <Box
                sx={{
                    px: 1,
                    py: 0.5,
                    bgcolor: colors.primary[400],
                    borderBottom: 1,
                    borderColor: "divider",
                }}
            >
                <Typography>Amount Details / Breakdown</Typography>
            </Box>

            {/* Responsive grid layout */}
            <Box
                sx={{
                    display: "grid",
                    gap: 0.5,
                    gridTemplateColumns: {
                        xs: "repeat(auto-fit, minmax(220px, 1fr))",
                        sm: "repeat(auto-fit, minmax(240px, 1fr))",
                        md: "repeat(auto-fit, minmax(260px, 1fr))",
                        lg: "repeat(auto-fit, minmax(280px, 1fr))",
                        xl: "repeat(auto-fit, minmax(300px, 1fr))",
                    },
                    p: 0.5,
                }}
            >
                {items.map((it, idx) => (
                    <PairTile
                        key={idx}
                        label={it.label}
                        value={it.value}
                        emphasize={!!it.emphasize}
                        editable={it.editable}
                        onChange={it.onChange}
                    />
                ))}
            </Box>
        </Box>
    );
}
